export default {
    //Splash
    splash_message: 'Communication and training platform',

    //TTCC
    accept_ttcc: 'Accept Terms & Conditions',

    //Login
    welcome: 'Welcome!',
    welcome_message:
        'dots, your new technological ally in communication and training.',
    username: 'Username',
    password: 'Password',
    code: 'Code',
    recover_password: 'Recover password',
    log_in: 'Log in',
    log_in_biometrics: 'Login with biometric data',
    create_user: 'Create user',
    recover_access_to_account:
        'Enter your username to recover access to your account',
    back: 'Back',
    enter_new_password: 'Enter the code and your new password',
    enter_code: 'Enter the code',
    new_password: 'New password',
    repeat_new_password: 'Repeat new password',
    validate: 'Validate',
    complete_all_fields: 'Complete all fields',
    passwords_do_not_match: 'Passwords do not match',
    user_created_successfully: 'User created successfully',
    create_user: 'Create user',
    required_fields: 'Required fields',
    confirm_your_email: 'Confirm your email',
    confirm_your_phone: 'Confirm your phone',
    confirm_password: 'Confirm Password',
    modifying_email: 'You are modifying your email',
    validate_code: 'Validate code',
    code_sent_successfully: 'Code sent successfully',
    password_reset: 'Your password has been successfully reset',
    enter_confirmation_code: 'Enter your confirmation code',
    enter_your_new_email: 'Enter your new email',
    //nuevos al 01-08-2024
    user_does_not_exist: "Oops! We couldn't find your account",
    contact_the_administrator:
        'It seems the user you entered does not exist.\nVerify that it is correctly written\nor contact the administrator.',
    invalid_user_or_pass: 'Invalid username and/or password',
    info_is_not_correct: 'Some of the information is incorrect, please try again.',
    enter_user: 'Please enter a username',
    nonexistent_user: 'Nonexistent user. Please try again.',
    incorrect_code: 'Incorrect code',
    change_saved_successfully: 'Change saved successfully',
    pass_changed_successfully: 'Password changed successfully',
    check_your_email: 'Check your email for the validation code',
    eight_characters: '*Must contain more than 8 characters',
    one_uppercase_letter: '*Must contain at least 1 uppercase letter',
    one_special_character: '*Must contain at least 1 special character (@,$,!,#,?)',
    pass_requirements:
        'You must meet the following requirements:\n\n*Must contain more than 8 characters\n*Must contain at least 1 uppercase letter\n*Must contain at least 1 special character (e.g., $, !, #, ?)',
    select_date: 'Select a date',
    cannot_create_password: 'Cannot create password',
    complete_your_details: 'Complete your details to continue',
    validate_code: 'Validate code',
    enter_valid_number: 'You must enter a valid number',
    complete_numbers:
        'The "15" prefix must be removed so the final number has a total of 13 digits, example: +54 9 XXX XXX XXXX, you must complete the remaining 10 digits.',

    //Profile
    insufficient_permissions: 'Insufficient permissions',
    permissions_are_required:
        'Permissions are required to access the camera and photo gallery.',
    choose_font: 'Choose source',
    where_do_you_want: 'Where do you want to select the image from?',
    camera: 'Camera',
    gallery: 'Gallery',
    edit_photo: 'Edit photo',
    cancel: 'Cancel',
    save: 'Save',
    app: 'App',
    support: 'Support',
    other: 'Other',
    contact_channel: 'Contact channel',
    select_the_contact_channel: 'Select the contact channel',
    subject: 'Subject',
    write_the_subject: 'Write the subject',
    message: 'Message',
    write_a_comment: 'Write a comment',
    send: 'Send',
    sent_successfully: 'Sent successfully',
    thank_you_for_leaving_us_your_comments:
        'Thank you for leaving us your comments, soon you will be contacted.',
    close: 'Close',
    check_for_update: 'Check for update',
    clear_cache: 'Clear cache',
    delete_account: 'Delete account',
    log_out: 'Log out',
    notifications: 'Notifications',
    insufficient_permissions: 'Insufficient permissions',
    permissions_to_access:
        'Permissions are required to access the camera and photo gallery.',
    choose_font: 'Choose source',
    select_the_image: 'Where do you want to select the image from?',
    change_language: 'Change language',
    change_language_title: 'Important!',
    change_language_message:
        "To perform this action, an internet connection is required. This will delete the downloaded content for offline use. Please note that the change will only affect the app's content and not its structure, which depends on the language of your device.",
    logout_not_available: 'Logout not available',
    cant_logout:
        'You cannot log out at the moment because you are not connected to the internet. Please check your connection and try again.',
    //nuevos al 01-08-2024
    cache_cleared: 'Cache cleared successfully',
    deletes_the_content:
        'This action deletes the content downloaded for use of the app in offline mode. Make sure you are connected to continue browsing.',
    error_uploading_image: 'Error uploading image: ',
    there_was_an_error: 'There was an error uploading the image. Please try again.',
    //nuevos al 21-11-2024
    email: 'Email',
    phone: 'Phone',
    name: 'Name',
    last_name: 'Last name',
    role: 'Role',
    verify: 'Verify',
    verified: 'Verified',
    contact_channels: 'Contact channels',
    editing_your_email: 'You are editing your email',
    editing_your_phone: 'You are editing your phone number',
    modifying_your_email:
        "You are modifying your email, you will receive a code in your email to enter. If you haven't received the code yet, please check again.",
    modifying_your_phone:
        "You are modifying your phone number, you will receive an SMS code to enter. If you haven't received the code yet, please check again.",

    //Notifications
    all: 'All',
    unread: 'Unread',
    read: 'Read',
    seen: 'Seen',
    notifications: 'Notifications',
    here_you_will_find: 'Here you will find all alerts and notifications!',
    mark_all_read: 'Mark all as read',
    you_have_no_notifications: 'You have no notifications!',
    you_will_soon_start: 'You will soon start receiving new communications',

    //Buscador
    enter_your_search: 'Enter your search',
    no_results: 'No results',
    search_content: 'Search for content that interests you.',
    see: 'See',
    results_in: 'results in',
    see_less_results: 'See less results',
    all: 'All',
    wall: 'Wall',
    learning: 'Learning',
    benefits: 'Benefits',
    portfolio: 'Portfolio',
    retry: 'Retry',
    locked: 'Locked',
    pending: 'Pending',
    seen: 'Seen',
    approved: 'Approved',

    //Posts
    see_them: 'View all ',
    _comments: ' comments',
    reactions_from_other_users: 'Reactions from other users',
    not_connected_to_the_network: 'You are not connected to the network',
    comment: 'Comment',
    comments: 'Comments',
    write_a_comment: 'Write a comment',
    no_content: 'No content',
    not_connected_to_the_network: 'You are not connected to the network',
    reaction: 'Reaction',
    reactions: 'Reactions',
    first_comment: 'No comments Yet',
    no_comment: 'Be the first one',
    write_a_comment: 'Write a comment',
    no_publications: 'No publications',
    no_post_to_read: 'You have no posts to read.',
    views: 'views',
    reply: 'Reply',
    see: 'See ',
    more_answers: 'more answers',
    hide: 'Hide ',
    answers: ' answers',
    no_reactions: 'Still no reactions!',
    leave_your_reaction: 'Be the first to leave your reaction.',
    //nuevos al 01-08-2024
    full_survey: 'You have completed the survey!',
    thanks_for_participating:
        'Thanks for participating! Keep an eye on the wall for more updates.',
    sent_automatically: 'It will be sent automatically when you regain connection.',
    no_post_saved: 'No posts saved yet',
    see_your_favorite_content: 'Here you will see your favorite content.',
    //fechas
    instant: 'A few moments ago',
    hourFirst: 'Ago ',
    hour: ' hour',
    hours: ' hours',
    day: ' day',
    days: ' days',

    //Learning
    congratulations: 'Congratulations!',
    you_approved: 'You passed with ',
    you_completed: 'You have completed this course',
    you_disapproved: 'Disapproved evaluation',
    score: 'Score:',
    return_to_course: 'Back to Home',
    retry: 'Retry',
    it_is_available: 'It is now available',
    total_course_evaluation: 'Total course evaluation',
    evaluate_me: 'EVALUATE ME',
    completed_the_course: 'You completed the course',
    pending_approval: 'Pending approval',
    return: 'Back',
    continue_course: 'Continue course',
    you_have_made: 'You have completed ',
    of_the_course: ' of the course',
    locked: 'locked',
    pending: 'pending',
    seen: 'seen',
    complete: 'complete',
    reprobate: 'failed',
    sync_pend: 'sync pend.',
    in_progress: 'in progress',
    perform_evaluation: 'Perform evaluation',
    next_content: 'Next content',
    you_completed_all: 'You have completed all contents',
    final_evaluation: 'FINAL EVALUATION',
    retry_mayus: 'RETRY',
    see_more: '...more',
    see_less: '...less',
    back_to_course: 'BACK TO COURSE',
    click_to_see: 'Click to see',
    //Evaluaciones
    evaluation: 'Evaluation: ',
    of: ' of ',
    loading_evaluation: 'Loading evaluation...',
    select_option: 'You have to select an option to continue',
    select_one_answer: 'Please select at least one answer for each question.',
    exit_evaluation: 'Do you want to exit the evaluation?',
    your_answers_will_not_be_saved:
        'If you leave now, your answers will not be saved',
    continue_evaluation: 'Continue with the evaluation',
    leave_anyway: 'Leave anyway',
    try_again: 'Retry!',
    passed_the_evaluation: 'You have passed the evaluation',
    start_the_course_again:
        'You did not get enough grade to pass the assessment. Start the course again to be able to pass it.',
    evaluation_pending_approval: 'Evaluation pending approval',
    notification_result_evaluation:
        'You will soon receive a notification with the result of your evaluation',
    write_here: 'Write here...',
    close: 'Close',
    confirm: 'Confirm',
    sync_pending: 'Sync pending',
    view_certificate: 'View certificate',

    // nuevos al 27-01-2025
    course_download_in_process: 'Course download in process',
    course_is_downloading:
        'Please wait a few seconds. The course is downloading so you can access all content offline without any issues.',
    downloaded_course: 'Course downloaded successfully',
    you_can_train_offline: 'Done! You can now train offline.',
    delete_offline_course:
        'Do you want to delete the offline download of this course?',
    not_view_course_offline: 'You won’t be able to view this course offline.',
    course_is_not_available: 'The course is no longer available...',
    not_available_offline:
        'It’s no longer available offline, but you can download it again when needed.',
    content_download_in_process: 'Content download in process',
    content_is_downloading:
        'Please wait a few seconds. The content is downloading so you can access it all offline without any issues.',
    downloaded_content: 'Content downloaded successfully',
    delete_offline_content: 'Do you want to delete the offline content?',
    not_view_content_offline:
        'By deleting it, you will no longer be able to access the content offline.',
    content_is_not_available: 'The content is no longer available...',
    download_offline: 'Download offline',
    available_offline: 'Available offline',
    delete: 'Delete',
    //Stores
    your_progress_in_stores: 'Your progress in stores',
    map: 'See map',
    daily_survey: 'Daily survey',
    survey: 'Survey',
    matutino: 'MATUTINO',
    vespertino: 'VESPERTINO',
    form: 'Form',
    enter_a_number: 'Enter a number',
    campaign_expiration: 'CAMPAIGN EXPIRATION: ',
    store_indicators: 'Store Indicators',
    last_days: 'Corresponding to the last 30 days',
    main_indicators: 'Know the progress of the main indicators in store',
    store_information:
        'Find relevant store information to meet optimal Perfect Store levels',
    perform_executions:
        'Perform the following executions to know the status of the store',
    pending_mayus: 'PENDING',
    approved_mayus: 'APPROVED',
    in_review_mayus: 'IN REVIEW',
    redo_mayus: 'REDO',
    visited_mayus: 'VISITED',
    visited_mayus_sync: 'VISITED SYNC',
    visited_store_mayus: 'VISITED STORES',
    checkin_realized_sync: 'VISITED STORES SYNC',
    moderation_mayus: 'MODERATION',
    review_mayus: 'REVIEW',
    in_progress_mayus: 'IN PROGRESS',
    sync_pend_mayus: 'SYNC PEND.',
    locked_mayus: 'LOCKED',
    complete_mayus: 'COMPLETE',
    perfect_store: 'Perfect Store',
    execution: 'Execution',
    vouchers: 'Vouchers',
    send: 'Send',
    requires: 'Requires ',
    variation: 'Variation',
    validity: 'Validity: ',
    points: 'points',
    voucher_canceled: 'Voucher canceled',
    you_can_try_again: 'Don’t worry! You can try again.',
    voucher_successful: 'Voucher successful',
    successful_promo: 'The promo was successfully completed!',
    voucher_pending: 'Voucher pending',
    wait_for_the_validation: 'Wait for your voucher to be validated',
    your_code_is_being_scanned: 'Your code is being scanned ⏳',
    view_qr: 'View QR',
    return_to_store: 'Return to Store',
    stores_objective: 'It must meet the stores objective.',
    welcome_stores: 'We welcome you to stores!',
    tip_day:
        'Here you can visit your stores of the day, take the corresponding surveys and review your progress.',
    close_mayus: 'CLOSE',
    select_form: 'Select a form to get started',
    select_one_form: 'To start the survey you must select one of the forms.',
    answer_all_questions: 'You must answer all questions to continue.',
    schedule_not_found: 'The schedule for today was not found.',
    form_not_found: 'Form not found in the schedule.',
    send: 'Send',
    check_in: 'Check-in',
    check_out: 'Check-out',
    check_out_done: 'Check-out completed',
    off_route: 'You are off route, enter here to return to the agenda for',
    search_barcode: 'Search by barcode',
    no_agenda_today: 'You don’t have any agenda for today!',
    no_agenda_week: 'You don’t have an agenda for the week!',
    no_information_today:
        'You do not have an agenda for this date, if you have any questions, consult your supervisor.',
    no_information_week:
        'We are not receiving information for your user, if you have any questions please contact your supervisor.',
    //nuevos al 01-08-2024
    not_have_camera_permissions: 'You don’t have camera permissions',
    activate_from_settings: 'Enable this from your device settings to continue.',
    modify_permissions: 'Modify permissions',
    complete_fields: 'Complete the following fields to create a store',
    create: 'Create',
    store_name: 'Store Name',
    enter_store_name: 'Enter store name',
    sore_address: 'Address',
    enter_sore_address: 'Enter store address',
    cluster: 'Cluster',
    store_phone: 'Phone',
    enter_sore_phone: 'Enter store phone',
    activate_survey:
        'To activate the 1.1 Vespertino survey, you need to complete the store objectives. Objectives: ',
    inactive_vespertino: 'Vespertino inactive',
    active_vespertino: 'Vespertino active',
    completed_your_mandatory_objectives:
        'You have completed your mandatory objectives for the day, you can now perform your Vespertino.',
    complete_now: 'Complete now',
    perform_later: 'Perform later',
    back_to_your_agenda: 'Do you want to return to your daily agenda?',
    return_to_the_current_day:
        'You are viewing activities from previous days, if you tap continue, you will return to the current day: ',
    continue: 'Continue',
    reached_your_goal: 'You reached your goal!',
    search_by_barcode: 'Search by barcode',
    scan_the_barcode: 'Scan the barcode of any product\non the list of this survey.',
    return_to_form: 'Return to Form',
    product_not_found: 'Product not found',
    code_does_not_match: 'The code does not match any product related to this form.',
    search_another_product: 'Search another product',
    form_submitted_successfully: ' form submitted successfully!',
    send_new_survey: 'If you wish, you can send a new survey.',
    no_agenda_for_today: 'No agenda for today!',
    consult_your_supervisor:
        'You have no agenda for this date, if you have any questions, consult with your supervisor.',
    visiting_your_store: 'You are visiting your store ',
    you_can_check_out: 'You can check out without completing the survey: ',
    you_met_the_goal: 'You met the goal, there is no need to complete the form.',
    you_must_complete_the_survey: 'To check out, you must complete the survey: ',
    checkin_blocked: 'Check-in blocked',
    close_the_open_checkin: 'To continue, you need to close the open check-in.',
    close_the_checkin_opened_in:
        'To continue, you need to close the check-in opened in: ',
    checkin_out_of_range: 'Check-in out of range',
    more_meters_from_the_store: 'You are more than 150 meters from the store.',
    now_is_your_turn: 'Now it’s your turn!',
    surveys_in_progress: 'You have ongoing surveys: ',
    unfinished_surveys: 'You have unfinished surveys: ',
    want_to_checkout: 'Are you sure you want to check out?',
    selected_store: 'Selected store',
    checkout_blocked: 'Check-out blocked',
    uncompleted_forms: 'You have uncompleted forms!',
    checkout_anyway: 'Do you want to check out anyway?',
    go_to_survey: 'Go to survey',
    take_the_survey: 'You can now take the survey!',
    validity: 'Validity: ',
    search_store: 'Search store...',
    no_results_for_your_search: 'No results for your search',
    find_another_store: 'Find another store',
    //nuevos al 21-11-2024
    loading: 'Loading...',
    error_getting_data: 'Error getting data.',
    no_information_to_display: 'No information to display.',
    unzipping: 'Unzipping...',
    saving: 'Saving',
    loading_stores: 'Loading stores...',
    getting_stores: 'Getting stores...',
    request_has_failed: 'Maximum number of retries reached. The request has failed.',
    a_few_minutes: 'Loading stores...\nThis process may take a few minutes.',
    //nuevos al 27-01-2025
    assets_download_completed: 'Perfect Store assets download completed',
    perfect_store_download: 'Perfect Store success photo download complete',
    perfect_store_error: 'Error in downloading Perfect Store assets',
    connection_interrupted:
        'Connection interrupted, success photo will be decompressed once connection is restored.',
    decompressing_perfect_store: 'Decompressing Perfect Store',
    downloading_perfect_store: 'Downloading Perfect Store',
    saving_perfect_store: 'Saving Perfect Store',
    remain_downloaded: '\nRemaining to download ',
    assets: ' assets.',
    download_complete: 'Download complete',

    //Portfolio
    no_brands_to_show: 'No brands to show',
    no_products_to_show: 'No products to show',
    try_again_later: 'Try again later',
    portfolio: 'Portfolio',
    select_one: 'Select one of our brands to see their products and services.',
    learn_about: 'Learn about the full range of products and services in our App.',
    //nuevos al 01-08-2024
    brand: 'Brand',
    description: 'Description',
    ingredients: 'Ingredients',
    data_sheet: 'Data sheet',

    //Benefits
    points_can_be_exchanged: 'Can be exchanged for:',
    approved: 'Approved',
    cancelled: 'Cancelled',
    pending: 'Pending',
    redeemed: 'Redeemed',
    added_points: 'Points added',
    all: 'All',
    my_points: 'My Points',
    your_points: 'Your points',
    delivered: 'Delivered',
    no_benefits: 'No benefits yet',
    add_points: 'Earn points with your interactions to redeem them',
    no_history: 'No history yet',
    redeem_your_points:
        'Redeem your points and you will see your benefits history here',
    pending_approval: 'Pending approval',
    when_it_is_approved:
        'When it is approved, you will see it reflected in your benefits history',
    unredeemed_benefit: 'Unredeemed benefit',
    you_dont_have_enough_points:
        'You don’t have enough points to redeem this benefit',
    accept: 'Accept',
    units_available: ' units available',
    redeem_benefit: 'Redeem benefit',
    benefits_mayus: 'BENEFITS',
    history: 'HISTORY',
    there_was_a_mistake: 'There was a mistake',

    //Vouchers
    complete_to_redeem_the_voucher: 'Complete to redeem the voucher',
    valid_until: 'Valid until: ',
    quantity_purchased: 'Quantity purchased: ',
    redeem: 'Redeem',
    lumps: 'Lumps',
    voucher_redeemed: 'Voucher successfully redeemed',
    error_redeeming_voucher:
        'There was an error when redeeming the voucher. Try again.',
    validate_and_redeem_vouchers: 'Validate and redeem vouchers',
    to_get_started:
        'To get started, enter or scan the QR of your voucher with your camera',
    write_your_code: 'Write your code...',
    validate: 'Validate',
    back_to_store: 'Back to Store',
    scan_qr: 'Scan the QR',
    scan_on_the_voucher: 'To start, scan the QR code on the voucher',
    view_history: 'View history',
    voucher_history: 'Voucher history',
    voucher_history_description:
        'This history allows you to accurately track redemptions, making it easier to follow and manage your accumulated rewards.',
    see_more: 'See more',
    see_less: 'See less',

    //Faltantes
    upload_image: 'Upload image',
    uploaded_image: 'Uploaded image',
    photo: 'Photo',
    edit: 'Edit',
    delete: 'Delete',
    enter_a_comment: 'Enter a comment',
    enter_a_value: 'Enter a value',
    want_to_check_out: 'Are you sure you want to check out?',
    not_check_in_again:
        'Once confirmed, you will not be able to check in again until your next visit.',

    //Alert
    alert: 'Alert',
    enter_characters: 'You must enter 10 characters after the prefix',
    numerical_field: 'The field to edit must be numeric, without spaces or letters.',
    enter_date_of_birth: 'Enter a valid date of birth in the format YYYY-MM-DD.',
    session_expired: 'Session expired',
    your_session_has_expired: 'Your session has expired. Please try again.',
    error: 'Error',
    error_occurred: 'An error occurred while trying to change the password.',
    email_verification_code_incorrect: 'The email verification code is incorrect.',
    phone_verification_code_incorrect: 'The phone verification code is incorrect.',
    no_checkin_found: 'Check-in not found.',

    //trivia
    your_position: 'Your position',
    play_again: 'Play again!',
    next: 'Next',
    position: 'Position',
    Questions: 'Question:',
    answer_right: 'The correct answer is:',
    game_completed_title1: 'Game completed!',
    game_completed_title2: 'Congratulations!',
    game_completed_title3: 'You finished the trivia.',
    game_completed_title4:
        'Ready to see your results? Discover how many answers you got right',
    game_unfinished_title1: 'Time is up for answering this or the questions.',
    game_unfinished_title2:
        "But don't worry, keep playing and show your knowledge in the next one!",
    tomorrow_again: 'New attempt tomorrow!',
    no_ranking_available_title: '¡Sé el primero en jugar!',
    no_ranking_text:
        'Todavía no hay posiciones. /nCompletá la trivia y estrená el ranking',
    no_trivia_available_title: '¡Sin trivias por ahora!',
    no_trivia_text: 'Pronto llegarán nuevas.',
    no_trivia_text2: '¡Estate atento!',
    no_podium_title: '¡El podio ya tiene dueños!',
    no_podium_text: '¿Jugaste ya? Sumate al ranking y mirá dónde quedás.',
    no_ranking_no_trivia_title: '¡Sin ranking disponible!',
    no_ranking_no_trivia_text:
        'Aún no hay partidas jugadas. ¡Pronto habrá novedades!',
    mensual: 'MENSUAL',
    acumulado: 'ACUMULADO',

    //Gamification
    game_again: '¡Vuelve a intentarlo!',
    game_Fail: 'No obtuviste el puntaje\nnecesario para avanzar.',
    game_rulette_again:
        '¡Gira la ruleta nuevamente\ny seguí jugando!\nNo obtuviste el puntaje\nnecesario para avanzar.',
    game_OK: 'Has aprobado el cuestionario.\nEstas mas cerca del primer puesto.',
}
